// تعيين التذكرة لأكثر من موظف دعم.
// التذاكر الجديدة ترجع `assignees`، والقديمة فيها `assignedTo` فقط — كل الشاشات تقرأ من هنا.

const clean = (value) => (value == null ? '' : String(value).trim());

export const getTicketAssignees = (ticket) => {
    const seen = new Set();
    const result = [];
    (Array.isArray(ticket?.assignees) ? ticket.assignees : []).forEach((item) => {
        const userId = clean(item?.userId ?? item?._id ?? item?.id);
        if (!userId || seen.has(userId)) return;
        seen.add(userId);
        result.push({ userId, name: clean(item?.name) || null, email: clean(item?.email) || null });
    });
    if (result.length) return result;

    const legacyId = clean(ticket?.assignedTo);
    return legacyId
        ? [{ userId: legacyId, name: clean(ticket?.assignedToName) || null, email: clean(ticket?.assignedToEmail) || null }]
        : [];
};

export const getTicketAssigneeIds = (ticket) => getTicketAssignees(ticket).map((assignee) => assignee.userId);

export const isTicketAssignedTo = (ticket, userId) => {
    const id = clean(userId);
    return Boolean(id) && getTicketAssigneeIds(ticket).includes(id);
};

// فلتر "المعيّن" المستخدم في قوائم التذاكر والتقارير: all | unassigned | <userId>
export const matchesAssigneeFilter = (ticket, filterValue) => {
    if (!filterValue || filterValue === 'all') return true;
    if (filterValue === 'unassigned') return getTicketAssigneeIds(ticket).length === 0;
    return isTicketAssignedTo(ticket, filterValue);
};

// يحوّل موظفي التذكرة لعناصر اختيار، مع استكمال الصورة والمسمى الوظيفي من قائمة موظفي الدعم.
export const toAssigneeOptions = (ticket, adminOptions = [], lang) =>
    getTicketAssignees(ticket).map((assignee) => {
        const found = adminOptions.find((option) => clean(option?.value) === assignee.userId);
        return found || {
            label: assignee.name || assignee.email || assignee.userId,
            value: assignee.userId,
            email: assignee.email || '',
            lang
        };
    });

export const buildAssigneesPayload = (selectedOptions) => ({
    assignees: (Array.isArray(selectedOptions) ? selectedOptions : [])
        .filter((option) => clean(option?.value))
        .map((option) => ({
            userId: clean(option.value),
            name: clean(option.label),
            email: clean(option.email)
        }))
});

export const getAssigneeDisplayName = (assignee, adminOptions = []) => {
    const found = adminOptions.find((option) => clean(option?.value) === assignee?.userId);
    return assignee?.name || found?.label || assignee?.email || assignee?.userId || '';
};

export const formatAssigneeNames = (names, lang) =>
    (names || []).filter(Boolean).join(lang === 'ar' ? '، ' : ', ');
